/**
 * MCPaaS reports two different `status` vocabularies, and confusing them is a
 * live bug rather than a nitpick:
 *
 * - the tool ROW:              `active` | `paused` | `init`
 * - the tool DEFINITION VERSION: `draft` | `published` | `deprecated` | `retired`
 *
 * `POST /tools:from_nexset` returns the *version* status. With `publish: true`
 * it creates the row already active and reports `published`, so a caller that
 * only looks for `active` concludes the tool is inactive and fires a redundant
 * `:activate`.
 *
 * That call is OPERATOR-only server-side. A Marketplace grantee holds `sharer`,
 * so it 403s and a successful creation surfaces to the user as a failure.
 */
export interface ToolCreationResult {
  status?: string | null;
  tool_status?: string | null;
}

/** True when creation already left the tool usable, so `:activate` is a no-op. */
export const isToolAlreadyActive = (result: ToolCreationResult): boolean =>
  result.status === 'published' || result.status === 'active' || result.tool_status === 'active';
